import * as React from "react"
import { batch } from "@preact/signals-react"
import { Box } from "@mui/material"
import { ImageSeeker } from "@ui-seeker/core"

import { imageModal, titleModal } from "@signals"
import { useBuildExternalURL } from "@hooks"


export default function ImageSkuBlock({ skuID, siteID, productID, date=null, imageURL, contentProps, imageProps, skuName="", isClickable=true }) {
	const { imageURL: builtImageURL } = useBuildExternalURL({
		imageData: { skuID, siteID, productID, date }
	})
	const image = imageURL || builtImageURL

	const handleClick = () => {
		if (!isClickable) return null
        batch(() => {
            imageModal.value = image
            titleModal.value = skuName
        })
	}

	return <Box
		sx={{ position: 'relative', overflow: 'hidden', width: 100, height: 100, border: '2px solid', borderColor: "divider", margin: "0 auto", ...contentProps?.sx }}
		onClick={handleClick}
	>
		<ImageSeeker
			src={image}
			defaultImage="/images/defaultImage.png"
			{...imageProps}
			sx={{ 
				width: 100,
				height: 100,
				objectFit: 'contain',
				objectPositive:'center',
				...imageProps?.sx
			}}
		/>
	</Box>
}